// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
export interface IAvailableJks {
  /** ID ЖК **/
  id: number;
  /** Ссылка на карточку ЖК **/
  link: string;
  /** Название **/
  name: string;
}

export interface IPromoBank {
  /** Ссылка на страницу ипотеки для партнеров. Deprecated, use is_partner **/
  cianMortgagePartnerLink?: string;
  /** ID банка **/
  id: number;
  /** Является ли партнером Циан ипотеки **/
  isPartner?: boolean;
  /** Логотип банка **/
  logoUrl?: string;
  /** Название **/
  name: string;
  /** URL второго, круглого логотипа компании **/
  secondRoundImageUrl?: string;
  /** URL второго, квадратного логотипа компании **/
  secondSquareImageUrl?: string;
}

export interface IPromoBank {
  /** Ссылка на страницу ипотеки для партнеров. Deprecated, use is_partner **/
  cianMortgagePartnerLink?: string;
  /** ID банка **/
  id: number;
  /** Является ли партнером Циан ипотеки **/
  isPartner?: boolean;
  /** Логотип банка **/
  logoUrl?: string;
  /** Название **/
  name: string;
  /** URL второго, круглого логотипа компании **/
  secondRoundImageUrl?: string;
  /** URL второго, квадратного логотипа компании **/
  secondSquareImageUrl?: string;
}

export interface IFeature {
  /** Название **/
  name: string;
  /** Значение **/
  value: string;
}

export interface IMortgageParams {
  /** Процентная ставка (0.0 - 100.0) **/
  interestRate?: number;
  /** Максимальная сумма кредита **/
  maxCredit?: number;
  /** Максимальный срок, лет **/
  maxLoanTerm?: number;
  /** Первоначальный взнос в %(0.0 - 100.0) **/
  minInitialPaymentRate?: number;
}

export interface IPromoInfo {
  /** Логотип застройщика/агента **/
  authorLogoUrl?: string;
  /** Название (имя) застройщика/агента **/
  authorName?: string;
  /** Realty user id, разместившего акцию **/
  authorRealtyUserId?: number;
  /** Список ЖК в которых доступна акция **/
  availableJks?: IAvailableJks[];
  /** Банк - автор **/
  bank?: IPromoBank;
  /** Банки **/
  banks: IPromoBank[];
  /** ID компании, разместившей акцию **/
  companyId?: number;
  /** Описание акции **/
  description?: string;
  /** Срок действия акции **/
  end?: string;
  /** Особенности акци **/
  features?: IFeature[];
  /** Акция от банка **/
  isFromBank?: boolean;
  /** Акция от застройщика **/
  isFromBuilder: boolean;
  /** Параметры акции по ипотеке **/
  mortgageParams?: IMortgageParams;
  /** Название акции **/
  name: string;
  /** ID Акции. Deprecated (используй unique_promo_id) **/
  promoId: number;
  /** Изображение для акции **/
  promoImage?: string;
  /** Тип акции **/
  promoType: EPromoType;
  /** Дата начала действия акции **/
  start?: string;
  /** Подзаголовок акции **/
  subtitle?: string;
  /** ID акции **/
  uniquePromoId: string;
}
export enum EPromoType {
  /** Акция от банка **/
  'Bank' = 'bank',
  /** Бонусы **/
  'Bonus' = 'bonus',
  /** Циан ипотека **/
  'CianMortgage' = 'cianMortgage',
  /** Скидки **/
  'Discount' = 'discount',
  /** Материнский капитал **/
  'MaternalCapital' = 'maternalCapital',
  /** Военная ипотека **/
  'MilitaryMortgage' = 'militaryMortgage',
  /** Ипотека **/
  'Mortgage' = 'mortgage',
  /** Рассрочка **/
  'Installment' = 'installment',
}
